import {
  TICKET_UPDATE,
  TICKET_FETCH,
  TICKET_FETCH_SUCCESS,
  TICKET_FETCH_RESET,
  TICKETS_FETCH,
  TICKETS_FETCH_SUCCESS,
  TICKETS_FETCH_RESET,
  TICKET_STATUS_FETCH,
  TICKET_STATUS_FETCH_SUCCESS,
  TICKET_STATUS_FETCH_RESET,
  TICKETS_EXPORT_EXCEL,
} from './types';

export const ticketUpdate = values => {
  return {
    type: TICKET_UPDATE,
    payload: values,
  };
};

export const ticketFetch = id => {
  return {
    type: TICKET_FETCH,
    payload: id,
  };
};

export const ticketFetchSuccess = payload => {
  return {
    type: TICKET_FETCH_SUCCESS,
    payload: payload,
  };
};

export const ticketFetchReset = () => {
  return {
    type: TICKET_FETCH_RESET,
  };
};

export const ticketsFetch = payload => {
  return {
    type: TICKETS_FETCH,
    payload: payload,
  };
};

export const ticketsFetchSuccess = payload => {
  return {
    type: TICKETS_FETCH_SUCCESS,
    payload: payload,
  };
};

export const ticketsFetchReset = () => {
  return {
    type: TICKETS_FETCH_RESET,
  };
};

export const ticketStatusFetch = payload => {
  return {
    type: TICKET_STATUS_FETCH,
    payload: payload,
  };
};

export const ticketStatusFetchSuccess = payload => {
  return {
    type: TICKET_STATUS_FETCH_SUCCESS,
    payload: payload,
  };
};

export const ticketStatusFetchReset = () => {
  return {
    type: TICKET_STATUS_FETCH_RESET,
  };
};

export const ticketsExportExcel = payload => {
  return {
    type: TICKETS_EXPORT_EXCEL,
    payload: payload,
  };
};
